import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

import { Filter } from 'app/shared/filter';
import { HttpErrorHandler } from 'app/shared/http-error-handler';

import { NotificationFilter, NotificationSender } from 'app/_models/notification';
import { NotificationService } from 'app/_services/notification.service';
import { NotificationSenderService } from 'app/_services/notification-sender.service';
import { OptionMapper } from 'app/_models/pojos';

@Component({
  selector: 'app-notification-filter',
  templateUrl: './notification-filter.component.html',
})
export class NotificationFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: NotificationFilter;

  search: string;
  senders: NotificationSender[] = [];
  states: OptionMapper[] = [];

  startDate: Date;
  endDate: Date;

  constructor(
    private fb: FormBuilder,
    private notificationService: NotificationService,
    private notificationSenderService: NotificationSenderService,
    private router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    super();
    this.form = fb.group({
      search: [''],
      status: [''],
      sender: [''],
      start_date: [''],
      end_date: [''],
    });
  }

  ngOnInit() {
    this.filter = new NotificationFilter(this.filterParams);

    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }

    this.getOptions();
  }

  getOptions() {
    this.notificationService.getOptions().subscribe(
      (data) => {
        this.states = OptionMapper.generateCollectionFromApi(data['actions']['POST']['status']['choices']);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );

    this.senders = [];
    this.notificationSenderService.rawList().subscribe(
      (data) => {
        data.forEach((item) => {
          const sender = new NotificationSender();
          this.senders.push(sender.apiMap(item));
        });
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  onSubmit() {
    this.filter.start_date = '';
    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    }

    this.filter.end_date = '';
    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    }

    if (this.filterParams['o'] !== undefined) {
      this.filter['o'] = this.filterParams['o'];
    }

    this.router.navigate(['/notifications', NotificationFilter.serializeRouterParams(this.filter)]);
  }
}



// WEBPACK FOOTER //
// ./src/app/notifications/notification-filter/notification-filter.component.ts